<div *ngIf="checkViewMode('edit')" class="form-group switch-group">
  <ui-switch [(ngModel)]="value" [disabled]="disabled ? true : false" (valueChange)="onValueChange($event)"></ui-switch>
</div>

<div *ngIf="checkViewMode('view')" class="m-switch-text-view d-print-none">
  <ui-switch [checked]="value" [disabled]="true"></ui-switch>
</div>

<div class="m-switch-text-view d-none d-print-block">
    <span>{{attribute.value == 'true' ? 'Sim' : 'Não'}}</span>
</div>

